import { Card } from "./Card";

/** 빈 목록 placeholder. */
export function EmptyState({ children }: { children: React.ReactNode }) {
  return (
    <Card className="px-6 py-16 text-center text-sm text-muted">{children}</Card>
  );
}
